export const PacksDetails = {
  DAILY_PASS: "Daily pass",
  WEEKLY_PASS: "Weekly pass",
};

